import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const brawlstars: GameSettings = {
  enabledLocales: [
    "en",
    "fr",
    "de",
    "it",
    "ja",
    "ko",
    "pl",
    "pt",
    "ru",
    "es",
    "tr",
    "zh",
    "zh-hans",
  ],
  enabledTabs: ["news", "community", "esport", "blog"],
  enabledNotificationTypes: ["standard", "medium", "high"],
  referenceWidth: 993,
  availableCategories: [
    {
      id: "release-notes",
      name: {
        en: "Release Notes",
        fr: "Notes de publication",
        de: "Versionshinweise",
        it: "Note di rilascio",
        ja: "リリース情報",
        ko: "새 소식",
        pl: "Informacje o Wydaniu",
        pt: "Notas de Lançamento",
        ru: "Информация о версии",
        es: "Notas de actualización",
        tr: "Sürüm Notları",
        zh: "更新說明",
      },
      color: "#62D43F",
    },
    {
      id: "strategy",
      name: {
        en: "Strategy",
        fr: "Stratégie",
        de: "Strategie",
        it: "Strategia",
        ja: "ストラテジー",
        ko: "전략",
        pl: "Strategia",
        pt: "Estratégia",
        ru: "Стратегия",
        es: "Estrategia",
        tr: "Strateji",
        zh: "攻略",
      },
      color: "#DB2EF4",
    },
    {
      id: "game-updates",
      name: {
        en: "Game Updates",
        fr: "Mises à jour",
        de: "Updates",
        it: "Aggiornamenti",
        ja: "アップデート",
        ko: "업데이트",
        pl: "Aktualizacje gry",
        pt: "Novidades do jogo",
        ru: "Обновления",
        es: "Actualizaciones",
        tr: "Oyun Güncellemeleri",
        zh: "遊戲更新",
      },
      color: "#F5D932",
    },
    {
      id: "community",
      name: {
        en: "Community",
        fr: "Communauté",
        de: "Community",
        it: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        pl: "Wspólnota",
        pt: "Comunidade",
        ru: "Сообщество",
        es: "Comunidad",
        tr: "Topluluk",
        zh: "社群",
      },
      color: "#DB2EF4",
    },
    {
      id: "news",
      name: {
        en: "News",
        fr: "Nouveautés",
        de: "News",
        it: "Notizie",
        ja: "新着",
        ko: "뉴스",
        pl: "Aktualności",
        pt: "Notícias",
        ru: "Новости",
        es: "Novedades",
        tr: "Haberler",
        zh: "最新情報",
      },
      color: "#4AA4F8",
    },
    {
      id: "video",
      name: {
        en: "Video",
        fr: "Video",
        de: "Video",
        it: "Video",
        ja: "ビデオ",
        ko: "동영상",
        pl: "Video",
        pt: "Video",
        ru: "видео",
        es: "Video",
        tr: "Video",
        zh: "動畫",
      },
      color: "#932EF4",
    },
    {
      id: "esports",
      name: {
        en: "Esports",
        fr: "Esports",
        de: "Esports",
        it: "Esports",
        ja: "eスポーツ",
        ko: "이스포츠",
        pl: "Esports",
        pt: "Esports",
        ru: "Киберспорт",
        es: "Esports",
        tr: "Espor",
        zh: "賽事情報",
      },
      color: "#F5AB32",
    },
    {
      id: "highlight",
      name: {
        en: "Highlight",
        fr: "Temps fort",
        de: "Höhepunkt",
        it: "In evidenza",
        ja: "ハイライト",
        ko: "하이라이트",
        pl: "Wyróżnienie",
        pt: "Destaque",
        ru: "Важное",
        es: "Destacado",
        tr: "Önemli anlar",
        zh: "精選對戰",
      },
      color: "#F5AB32",
    },
  ],
  esport: {
    enableCarouselTitle: true,
    enableCarouselSubtitle: true,
  },
  resolutions: {
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 800,
        height: 433,
      },
    },
    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.newsEntryArticle]: {
      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
      heroImage: {
        width: 1600,
        height: 443,
      },

      largeThumbnail: {
        width: 800,
        height: 433,
      },
    },

    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 800,
        height: 433,
      },
    },

    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },

    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },

    [contentTypeIds.socialLink]: {
      socialLinkImage: {
        width: 200,
        height: 150,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },

    [contentTypeIds.featureBlock]: {
      featureThumbnail: null,
    },

    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 1200,
        height: 750,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 1200,
        height: 750,
      },
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },

    [contentTypeIds.esportLiveEventEntry]: {
      carouselImage: {
        width: 960,
        height: 540,
      },

      eventPromotionLogo: {
        width: 128,
        height: 128,
      },
    },

    [contentTypeIds.esportCarouselEventEntry]: {
      carouselImage: {
        width: 960,
        height: 540,
      },
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 800,
        height: 433,
      },
    },

    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 1200,
        height: 750,
      },
      milestone1Image: {
        width: 400,
        height: 360,
      },

      milestone2Image: {
        width: 400,
        height: 360,
      },
      milestone3Image: {
        width: 400,
        height: 360,
      },
      milestone4Image: {
        width: 400,
        height: 360,
      },
      milestone5Image: {
        width: 400,
        height: 360,
      },
      milestone6Image: {
        width: 400,
        height: 360,
      },
      milestone7Image: {
        width: 400,
        height: 360,
      },
      milestone8Image: {
        width: 400,
        height: 360,
      },
    },

    [contentTypeIds.fullscreenEntryCarousel]: {
      backgroundMedia: {
        width: 1620,
        height: 1080,
      },
    },
  },

  enabledComposePages: ["news", "events"],

  availableButtonVariants: [
    "blue",
    "red",
    "green",
    "gold",
    "pink",
    "orange",
    "twitch",
  ],
  progressBarDefaultColor: "#3178F5",

  blogMeta: {
    site: "Brawl Stars",
    creator: "@BrawlStars",
  },

  activeContentInDays: {
    community: 90,
    news: 90,
    esport: 90,
  },

  supportPolls: true,
  supportTargetPolls: false,
  supportFullscreenEntries: true,
  supportProgressTrackerEntry: true,
  targetingFields: [
    "country",
    "countryExclude",
    "platform",
    "avatarIds",
    "campaignId",
  ],
  supercellMakeEnabled: true,
  eventPlatformEnabled: true,
  removeVoteInPollsEnabled: true,
  previewSubdomain: "brawlstars-fs",
};
